import { pxToRem } from '../../../../utils';
export var chatMessageReadStatusVariables = function chatMessageReadStatusVariables(siteVars) {
  return {
    bottomPosition: '0',
    bottomPositionCompact: pxToRem(-1),
    // Offset border around compact message
    color: siteVars.colorScheme.brand.foreground1,
    rightPosition: pxToRem(-17)
  };
};